import { ref } from "vue"
import ComponentesService from "@/services/ComponentesService"
import NiveisCombustivelConstant from "@/constants/NiveisCombustivelConstant";
import StatusComponenteConstant from "@/constants/StatusComponenteConstant";

class ComponenteCombustivelService {
    setup({ respostas, respostaObrigatoria, etapaComponente, identificador, modulo, resumoModulos }) {
        const respostaComponente = ref(respostas);
        const nivelInicial = respostaComponente.value || 'Baixo';
        const nivelSelecionado = ref(this._encontraValorNivel(nivelInicial));
        const statusResposta = ref(StatusComponenteConstant.NAO_PREENCHIDO.chave);
    
        if (!resumoModulos) {
            ComponentesService.salvarRespostaEstadoComponente(modulo, etapaComponente, identificador, nivelInicial);
            if (respostaComponente.value !== null) {
                statusResposta.value = this.controlarStatus(respostaObrigatoria, etapaComponente, identificador, modulo);
            }
        }
    
        return { nivelSelecionado, statusResposta };
    }

    controlarStatus(respostaObrigatoria, etapaComponente, identificador, modulo) {
        const statusResposta = ComponentesService.validaStatusRespostaComponente(respostaObrigatoria, true);
        ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta);
        return statusResposta;
    }

    _encontraValorNivel(nivel) {
        const nivelEncontrado = NiveisCombustivelConstant.NIVEIS.find(n => n.nivel === nivel);
        return nivelEncontrado ? nivelEncontrado.valor : 0;
    }
}

export default new ComponenteCombustivelService();